<template>
  <div id="app-container" class="wrapper">
    <div class="app-logo">
      <img :src="logoSrc" />
    </div>

    <div class="user-profile-holder">
      <span>Hi </span>
      <span class="user-profile-name">{{ userName }}</span>
    </div>

    <div class="dart-target">
      <div class="global-home" @click="openRoute('/Start')">
        <svg width="77" height="77">
          <image :xlink:href="globalHomeSrc" />
        </svg>
      </div>
    </div>

    <transition name="splash">
      <Loading v-if="isLoading == 1" />
    </transition>

    <transition name="fade">
      <Alert
        v-if="showAlert == 1"
        @close-alert="showAlert = 0"
        :alertMessage="alertMessage"
      />
    </transition>
  </div>

  <section>
    <div class="support-container">
      <div class="support-header">Support</div>
      
      <div class="support-content">
        <div class="support-section">
          <div class="support-section-title">Contact Us</div>
          <div class="support-item">
            <div class="support-label" style="color: #fff;">Whatsapp:</div>
            <div class="support-value"><a style="color: #27d267; text-decoration: none; font-weight: bold; display: block; padding: 5px 0; width: 100%; text-align: center; border:solid 1px #27d267; border-radius: 10px;" href="https://wa.me/2349155782844" target="_blank">+234 915 578 2844</a></div>
          </div>
          
        </div>

        <div class="support-section">
          <div class="support-section-title">Frequently Asked Questions</div>
          
          <div class="faq-item" v-for="(faq, index) in faqs" :key="index">
            <div class="faq-question" @click="toggleFaq(index)">
              <span>{{ faq.question }}</span>
              <span class="faq-toggle">{{ expandedFaqs[index] ? '−' : '+' }}</span>
            </div>
            <transition name="fade">
              <div v-if="expandedFaqs[index]" class="faq-answer">
                {{ faq.answer }}
              </div>
            </transition>
          </div>
        </div>

        <div class="support-section">
          <div class="support-section-title">Quick Links</div>
          <div class="quick-link-item" @click="openRoute('/Wallet')">
            <span>Wallet</span>
            <span>→</span>
          </div>
          <div class="quick-link-item" @click="openRoute('/Profile')">
            <span>Profile</span>
            <span>→</span>
          </div>
          <div class="quick-link-item" @click="openRoute('/play')">
            <span>Play Game</span>
            <span>→</span>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import Loading from "@/components/Modals/Loading.vue";
import Alert from "@/components/Modals/Alert.vue";

export default {
  components: { Loading, Alert },
  data() {
    return {
      logoSrc: require("../../assets/images/logo.png"),
      globalHomeSrc: require("../../assets/svg/global-home.svg"),
      userName: this.getUserData("name")?.split(" ")[0] || "User",
      isLoading: 0,
      showAlert: 0,
      alertMessage: "",
      expandedFaqs: {},
      faqs: [
        {
          question: "How do I fund my wallet?",
          answer: "Click on 'Wallet' from the main menu, then select 'FUND'. Choose your preferred amount and follow the instructions to complete the payment. You can also use the virtual account details provided to make a bank transfer.",
        },
        {
          question: "How do I withdraw funds?",
          answer: "Go to your Wallet page, click on 'WITHDRAW', select or enter the amount you want to withdraw, choose a beneficiary, and proceed. Make sure you have added a beneficiary account first.",
        },
        {
          question: "How do I play a game?",
          answer: "Click on 'Play !' from the main menu. Select a game element (Car, Candy, or Ball), choose your game type (Probability or Direct), select 6 items, enter your stake amount, and submit your game.",
        },
        {
          question: "What is the difference between Probability and Direct?",
          answer: "In Direct mode, all 6 items you select must match the 6 winning items exactly. In Probability mode, at least 4 of your 6 selected items must match any of the 6 winning items.",
        },
        {
          question: "How do I earn bonuses?",
          answer: "You can earn bonuses through: Sign-up bonus (N1,000), Daily bonus (N50 after your first play of the day), Referral bonus (N100 when you refer a friend), and by winning games.",
        },
        {
          question: "How long does payment verification take?",
          answer: "Payment verification typically takes a few minutes. The system will automatically check your payment status every 30 seconds for up to 5 minutes. If payment is not verified within this time, please contact support.",
        },
        {
          question: "What should I do if I encounter an error?",
          answer: "If you encounter any errors, please try refreshing the page. If the problem persists, contact our support team via email at support@operapandw.xyz or use the contact information provided on this page.",
        },
      ],
    };
  },
  methods: {
    getUserData(key = null) {
      var data = localStorage.getItem("user_data");

      if (data) {
        data = JSON.parse(data);
      }

      if (key && data) {
        return data[key];
      }

      return data;
    },
    openRoute(path) {
      this.$router.push(path);
    },
    toggleFaq(index) {
      // Vue 3 doesn't need $set, direct assignment works with reactivity
      this.expandedFaqs[index] = !this.expandedFaqs[index];
    },
  },
};
</script>

<style scoped>
.app-logo {
  text-align: center;
  margin-top: 70px;
}

.dart-target {
  text-align: center;
  margin-top: 10px;
}

.user-profile-holder {
  color: #fff;
  text-align: center;
  font-family: Angkor;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  letter-spacing: -0.333px;
  text-align: right;
  padding-right: 22%;
}

.support-container {
  max-width: 337px;
  margin: 0 auto;
  padding: 20px;
  color: #fff;
}

.support-header {
  color: #fff;
  text-align: center;
  font-family: Angkor;
  font-size: 32px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  letter-spacing: -0.333px;
  margin-top: 20px;
  margin-bottom: 30px;
}

.support-content {
  display: flex;
  flex-direction: column;
  gap: 30px;
}

.support-section {
  background: rgba(87, 0, 101, 0.3);
  border-radius: 20px;
  padding: 20px;
  border: 2px solid #570065;
}

.support-section-title {
  color: #fff;
  font-family: Angkor;
  font-size: 20px;
  font-weight: 400;
  margin-bottom: 15px;
  text-align: center;
  letter-spacing: -0.333px;
}

.support-item {
  margin-bottom: 15px;
  padding: 10px;
  background: rgba(0, 0, 0, 0.3);
  border-radius: 10px;
}

.support-label {
  color: #27d267;
  font-family: DM Sans;
  font-size: 14px;
  font-weight: 600;
  margin-bottom: 5px;
}

.support-value {
  color: #fff;
  font-family: DM Sans;
  font-size: 14px;
  font-weight: 400;
  word-break: break-all;
}

.faq-item {
  margin-bottom: 15px;
  background: rgba(0, 0, 0, 0.3);
  border-radius: 10px;
  overflow: hidden;
}

.faq-question {
  padding: 15px;
  color: #fff;
  font-family: DM Sans;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;
  transition: background 0.3s ease;
}

.faq-question:hover {
  background: rgba(87, 0, 101, 0.5);
}

.faq-toggle {
  color: #27d267;
  font-size: 20px;
  font-weight: bold;
  min-width: 20px;
  text-align: center;
}

.faq-answer {
  padding: 15px;
  color: #fff;
  font-family: DM Sans;
  font-size: 13px;
  font-weight: 400;
  line-height: 1.6;
  background: rgba(0, 0, 0, 0.2);
  border-top: 1px solid rgba(255, 255, 255, 0.1);
}

.quick-link-item {
  padding: 15px;
  margin-bottom: 10px;
  background: rgba(0, 0, 0, 0.3);
  border-radius: 10px;
  color: #fff;
  font-family: DM Sans;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;
  transition: all 0.3s ease;
}

.quick-link-item:hover {
  background: rgba(87, 0, 101, 0.5);
  transform: translateX(5px);
}

.quick-link-item span:last-child {
  color: #27d267;
  font-size: 20px;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>
